/**
 * 🔴 #339 (20/09/2026): a tela é de celular? Mora fora do `LinhaRecolhivel.tsx` porque o fast refresh do Vite exige que o arquivo de
 * componente só exporte componentes (a trava de lint cobra).
 */
import { useEffect, useState } from 'react';

/** `true` quando a tela é estreita (o mesmo corte do Tailwind `sm`, 640 px). Sem `localStorage`, sem estado global. */
export function useTelaDeCelular(): boolean {
  const [estreita, setEstreita] = useState(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia('(max-width: 639px)').matches
      : false,
  );
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia('(max-width: 639px)');
    const ouvir = (e: MediaQueryListEvent) => setEstreita(e.matches);
    setEstreita(mq.matches);
    // Safari antigo não tem addEventListener no MediaQueryList.
    if (mq.addEventListener) {
      mq.addEventListener('change', ouvir);
      return () => mq.removeEventListener('change', ouvir);
    }
    mq.addListener(ouvir);
    return () => mq.removeListener(ouvir);
  }, []);
  return estreita;
}
